import axios from 'axios'
import { baseUrl } from '@/conf'
//import app from '../main' // import the app instance

const apiClient = axios.create({
  // produkcija
  //baseURL: `/api`,
  // development
  baseURL: baseUrl + `/api`,
  //withCredentials: false, // This is the default
  withCredentials: true, // to enable passing of cookies, we use the withCredentials: true option (samo za cors -> vidi dodatak)
  // dodatak:
  // The XMLHttpRequest.withCredentials property is a Boolean that indicates
  // whether or not cross-site Access-Control requests should be made
  // using credentials such as cookies, authorization headers or TLS client certificates.
  // Setting withCredentials has no effect on same-site requests
  //
  // resenje:
  // Axios sends requests using XMLHttpRequest which will always attach cookies

  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// axios interceptors za progress bar
// ovo je prbaceno u @router/index.js (04 Global and Per-Route Guards - Next-Level Vue _ Vue Mastery)
// apiClient.interceptors.request.use(config => {
//   app.$Progress.start() // for every request start the progress
//   return config
// })

// apiClient.interceptors.response.use(response => {
//   app.$Progress.finish() // finish when a response is received
//   return response
// })

export default apiClient
